import {
    USER_DATA_CHANGED, USER_DATA_INIT
} from "../consts/consts";

const initialState = {
    status: USER_DATA_INIT
};

const updateUserData = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case USER_DATA_CHANGED:
            return action.payload;
        default:
            return state.userData;
    }

};

export {
    updateUserData
}